<div class="image-editor">
  <!-- Dropdown menu -->
  <div class="editor-content scroll-style" *ngIf="!isViewAll"
    style="overflow: auto; overflow-x: hidden; max-height: 40vh">
    <!-- Dropdown menu -->
    <ul nz-menu nzMode="inline">
      <!-- Cấu hình cơ bản -->
      <li nz-submenu nzTitle="Thông số cơ bản">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- set Độ mờ đục -->
            <div class="mb-3 field-row">
              <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  min-height: 32px;
                ">
                <p class="m-0">Độ mờ đục</p>
                <nz-input-number [ngModel]="class['image-img'].opacity" [nzMin]="0" [nzMax]="1" style="width: 40%"
                  [nzStep]="0.01" [nzFormatter]="formatterPercent" (ngModelChange)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.01" [ngModel]="class['image-img'].opacity | vhnumber"
                (ngModelChange)="class['image-img'].opacity = $event" (nzOnAfterChange)="updateClass()"></nz-slider>
            </div>
            <!-- set độ co giãn -->
            <div class="field-row">
              <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  min-height: 32px;
                ">
                <p class="m-0">Độ co giãn</p>
                <nz-input-number [ngModel]="config['transform_image'].transform_scale" [nzMin]="0.1" [nzMax]="2"
                  [nzStep]="0.1" style="width: 40%" [nzFormatter]="formatterPercent" (ngModelChange)="updateScale()">
                </nz-input-number>
              </div>
              <nz-slider [(ngModel)]="config['transform_image'].transform_scale" (ngModelChange)="updateScale()"
                [nzMin]="0.1" [nzMax]="2" [nzStep]="0.1"></nz-slider>
            </div>
            <!-- set khoảng cách giữa ảnh chính và list ảnh nhỏ -->
            <div class="field-row">
              <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  min-height: 32px;
                ">
                <p class="m-0">Khoảng cách</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" style="width: 40%"
                  [ngModel]="class['image-video-detail']['gap'] | vhnumber"
                  (ngModelChange)="class['image-video-detail']['gap'] = $event + 'px'" (nzOnAfterChange)="updateClass()">
                </nz-input-number>
              </div>
              <nz-row>
                <nz-col nzSpan="24">
                  <nz-slider [nzMin]="0" [nzMax]="100" [ngModel]="class['image-video-detail']['gap'] | vhnumber"
                    (ngModelChange)="
                      class['image-video-detail']['gap'] = $event + 'px'
                    " (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </nz-col>
              </nz-row>
            </div>
          </div>
        </div>
      </li>
      <!-- set kiểu viền và màu viền -->
      <li nz-submenu nzTitle="Đường viền ảnh chính">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['image-img']"
          [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(style_fields[8])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình filter -->
      <li nz-submenu nzTitle="Bộ lọc hình ảnh">
        <app-filter-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config" [filterConfig]="config['filter']"
          [opacityClass]="class['image-img']" [id_object]="objectChoosing._id" (isViewAll)="isOpenViewAll($event)">
        </app-filter-config>
      </li>
      <!-- Cấu hình object-fit -->
      <li nz-submenu nzTitle="Độ bao phủ hình ảnh">
        <div class="editor-field">
          <app-object-fit-config [device]="device" [class]="class" [objectFitClass]="class['image-img']"
            [style_field]="style_fields[2]" (isViewAll)="isOpenViewAll($event)" [objectChoosing]="objectChoosing">
          </app-object-fit-config>
        </div>
      </li>
    </ul>
  </div>
  <!-- Mở rộng editor-content-->
  <div class="editor-content" *ngIf="isViewAll">
    <div class="return" (click)="isViewAll = !isViewAll" style="
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        margin-bottom: 5px;
      ">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll" style="font-weight: 500">
        {{ currentViewAll.title | translate }}</span>
    </div>
    <!-- Cấu hình filter chi tiết -->
    <div class="editor-field-body" *ngIf="currentViewAll.index == 2">
      <app-brightness-contrast-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
        [filterConfig]="config['filter']" [opacityClass]="class['image-img']" [staticdata]="staticdata"
        [id_object]="objectChoosing._id">
      </app-brightness-contrast-config>
    </div>
    <!-- Cấu hình bóng -->
    <div class="editor-field-body" *ngIf="currentViewAll.index == 3">
      <div class="field-row">
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          ">
          <p class="m-0" style="font-weight: 500; font-size: 14px">
            Vị trí hình ảnh
          </p>
        </div>
      </div>
      <div class="field-row">
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          ">
          <p class="m-0">Ngang</p>
          <nz-input-number [(ngModel)]="config['object_fit_image']['object_x']" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()" style="width: 40%"></nz-input-number>
        </div>
        <nz-slider [(ngModel)]="config['object_fit_image']['object_x']"
          (ngModelChange)="handleSetPositionImage()"></nz-slider>
      </div>
      <div class="field-row">
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          ">
          <p class="m-0">Dọc</p>
          <nz-input-number [nzStep]="1" [(ngModel)]="config['object_fit_image']['object_y']"
            (ngModelChange)="handleSetPositionImage()" style="width: 40%"></nz-input-number>
        </div>
        <nz-slider [(ngModel)]="config['object_fit_image']['object_y']"
          (ngModelChange)="handleSetPositionImage()"></nz-slider>
      </div>
    </div>
    <div class="editor-field-body" *ngIf="currentViewAll.index == 9">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['image-img']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>